import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import qs from 'qs';

import { API_URL, get } from 'lib/network/api';

import FullLayout from 'layout/FullLayout';
import CardPlay from 'components/CardPlay';
import Modal from 'components/Modal';
import ContentCardPass from 'components/ContentCardPass';
import ModalDatePicker from './ComponentsPage/ModalDate';

const ExhibitionPass = () => {
  const [searchParams] = useSearchParams();
  const currentParams = qs.parse(searchParams.toString(), { comma: true });
  const [openQuickShow, setOpenQuickShow] = useState(false);
  const [openDateModal, setOpenDateModal] = useState(false);
  const [selectedPass, setSelectedPass] = useState(null);
  const [query, setQuery] = useState({
    page: 1,
    limit: 50,
  });

  const fetchListPlay = async (query, currentParams) => {
    const { page, limit } = currentParams;

    const params = {
      page: page ? page : query.page,
      limit: limit ? limit : query.limit,
      category: 3,
    };

    const filteredParams = Object.fromEntries(
      Object.entries(params).filter(
        ([_, value]) => value !== undefined && value !== null && value !== '',
      ),
    );

    return get(
      `${API_URL}/api/event/package/no-login?${qs.stringify(filteredParams, {
        arrayFormat: 'repeat',
      })}`,
    );
  };

  const { data, isLoading, isError } = useQuery({
    queryKey: ['fetchListPlay', query, currentParams],
    queryFn: async ({ queryKey }) => fetchListPlay(queryKey[1], queryKey[2]),
  });

  const playSessions = data?.data || [];
  const pagination = data?.pagination || {};

  const onSelectedPass = (item) => {
    setOpenQuickShow(true);
    setSelectedPass(item);
  };

  const onBuyPackage = (selectedItme) => {
    setOpenDateModal(true);
    setSelectedPass(selectedItme);
  };

  return (
    <FullLayout>
      <div className="container mx-auto pt-6 pb-24 px-4 lg:px-8 xl:px-0">
        <div className="h-[250px] xl:h-[370px] relative">
          <img
            alt="play-exhibition"
            src="/kin/assest/image/play-exhibition.webp"
            className="absolute inset-0 h-full w-full object-cover rounded-lg"
          />
          <span className="absolute inset-0 flex items-center justify-center text-white font-bold text-2xl">
            Play & Exhibition Passes
          </span>
        </div>

        {/* Loading State */}
        {isLoading && <p className="text-center mt-6">Loading...</p>}

        {/* Error State */}
        {isError && (
          <p className="text-center mt-6 text-red-500">Terjadi kesalahan saat memuat data.</p>
        )}

        {/* Data Kosong */}
        {!isLoading && playSessions.length === 0 && (
          <p className="text-center mt-6 text-gray-500">Tidak ada data yang tersedia.</p>
        )}

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 mt-6 pb-20 gap-4">
          {playSessions.map((items, idx) => {
            return (
              <CardPlay key={idx} item={items} onQuickView={onSelectedPass} onBuy={onBuyPackage} />
            );
          })}
        </div>

        {openQuickShow && (
          <Modal
            open={openQuickShow}
            onRequestClose={() => setOpenQuickShow(false)}
            clickOverlay={true}>
            <ContentCardPass item={selectedPass} onClose={setOpenQuickShow} type={'view'} />
          </Modal>
        )}
        {openDateModal && (
          <ModalDatePicker
            open={openDateModal}
            onClose={() => setOpenDateModal(false)}
            item={selectedPass}
          />
        )}
      </div>
    </FullLayout>
  );
};

export default ExhibitionPass;
